import ComponentRegister from '../utils/ComponentRegister';

import CampaignsSearch from '../bundles/CampaignsSearch';
import StreamVideo from '../bundles/StreamVideo';
import MuiViewablePassword from '../bundles/MuiViewablePassword';

ComponentRegister.setup({
  CampaignsSearch,
  StreamVideo,
  MuiViewablePassword,
});
